import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FlowLayout, Input, RadioCards } from '@/ds'
import { useAppNavigate } from '@/lib/query-params'
import { acompanantesService } from '@/services/acompanantes'
import type { InviteChannel } from '@/services/acompanantes'
import { isValidEmail } from '@/services/checkin/rules'
import { useCheckinFlow } from '../CheckinFlow'
import { progressFor, stepPath } from '../flow'
import { phoneError } from '../phone'
import { useSave } from '../useSave'

/** Paso 1b · Invitar a un acompañante (CheckIn.dc.html step=1b). POSPUESTO: contra mock (D8). */
export function Invitar() {
  const { t } = useTranslation()
  const { go } = useAppNavigate()
  const { stay } = useCheckinFlow()
  const [name, setName] = useState('')
  const [channel, setChannel] = useState<InviteChannel>('whatsapp')
  const [contact, setContact] = useState('')
  const [touched, setTouched] = useState(false)
  const { saving, error, run } = useSave()

  const contactError = (() => {
    if (!touched) return undefined
    if (channel === 'email') return contact.trim() === '' ? t('v2.legacy.stepper.collectDataForm.errors.email.required') : isValidEmail(contact.trim()) ? undefined : t('v2.legacy.stepper.collectDataForm.errors.email.invalid')
    const e = phoneError(contact)
    return e === 'prefix' ? t('v2.checkin.datos.prefijo') : e === 'digits' ? t('v2.checkin.invitar.faltanCifras') : undefined
  })()

  const send = async () => {
    setTouched(true)
    const invalid = channel === 'email' ? !contact.trim() || !isValidEmail(contact.trim()) : phoneError(contact) !== null
    if (invalid) return
    const ok = await run(() => acompanantesService.invite(stay, { name: name.trim() || null, channel, contact }))
    if (ok) go(stepPath('1'))
  }

  return (
    <FlowLayout
      progress={{ ...progressFor('1b', stay, 'holder', null), backLabel: t('v2.checkin.atras.ocupantes'), onBack: () => go(stepPath('1')) }}
      title={t('v2.checkin.invitar.titulo')}
      intro={t('v2.checkin.invitar.intro')}
      primary={{ label: t(`v2.checkin.invitar.enviar_${channel}`), onClick: () => void send(), loading: saving }}
      footerMessage={error}
    >
      <Input label={t('v2.checkin.invitar.nombre')} help={t('v2.checkin.invitar.nombreAyuda')} value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
      <RadioCards
        label={t('v2.checkin.invitar.canal')}
        options={[
          { id: 'whatsapp', label: t('v2.checkin.invitar.whatsapp') },
          { id: 'email', label: t('v2.checkin.invitar.email') },
        ]}
        value={channel}
        onChange={(id) => {
          setChannel(id as InviteChannel)
          setContact('')
          setTouched(false)
        }}
      />
      {channel === 'whatsapp' ? (
        <Input label={t('v2.checkin.invitar.numero')} inputMode="tel" type="tel" autoComplete="off" value={contact} onChange={(e) => setContact(e.target.value)} onBlur={() => setTouched(true)} {...(contactError ? { error: contactError } : {})} />
      ) : (
        <Input label={t('v2.checkin.invitar.correo')} inputMode="email" type="email" autoComplete="off" value={contact} onChange={(e) => setContact(e.target.value)} onBlur={() => setTouched(true)} {...(contactError ? { error: contactError } : {})} />
      )}
    </FlowLayout>
  )
}
